import React from "react";
import { Box, Container } from "@mui/material";

/**
 * AdminLayout component for admin pages
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render
 * @returns {JSX.Element} AdminLayout component
 */
const AdminLayout = ({ children }) => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>{children}</Box>
    </Container>
  );
};

export default AdminLayout;
